export const formatTimestamp = (value, locale = navigator?.language || 'en-US') => {
  if (value === null || value === undefined || value === '') return 'N/A';

  let date;
  if (value?.toDate && typeof value.toDate === 'function') {
    date = value.toDate();
  } else if (value instanceof Date) {
    date = value;
  } else if (typeof value === 'string' || typeof value === 'number') {
    date = new Date(value);
  } else {
    return 'N/A';
  }

  if (Number.isNaN(date.getTime())) return 'N/A';

  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZoneName: 'short',
  }).format(date);
};

export const resolveUidToEmail = async (authService, uid) => {
  if (!uid) return 'N/A';
  const authUser = await authService.getUser(uid).catch(() => null);
  return authUser?.email || uid;
};
